export default "__VITE_ASSET__dvo5f70H__"